import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router/composables";
import { $post } from "@/plugins/api/api";
import { Paths } from "@/plugins/api/paths";
import { $get } from "@/plugins/api/api";
import { CheckApprovalAttendance } from "@/models/approval/ApprovalResponse";
import { CheckApprovalSearchRequest } from "@/models/approval/ApprovalRequest";
import { PetitionShiftAttendanceSearchRequest } from "@/models/nopetition/PetitionShiftAttendanceSearchRequest.vue";
import { EnumApprovalState, EnumCheckApproval } from "@/models/enum/Enum";

type Banner = {
  text: string;
  color: string;
  index: ApprovalIndex;
};

type ApprovalType = keyof typeof ApprovalType;

type ApprovalIndex = typeof ApprovalIndex[keyof typeof ApprovalIndex];

type Banner2 = {
  text: string;
  color: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckHome',
  setup(__props) {

const router = useRouter();

const ApprovalType = {
  Shift: "シフト申請",
  Vacation: "休暇申請",
  Overwork: "残業申請",
  Attendance: "勤務時間変更依頼",
  Earlytime: "早出申請"
} as const;
const ApprovalIndex = {
  Vacation: 0,
  Shift: 1,
  Overwork: 2,
  Attendance: 3,
  Earlytime: 4
} as const;
const items = ref<Banner[]>([]);

const routerName = "CheckApproval";

const getBanner = (type: ApprovalType, count = 0): Banner => {
  const text = ApprovalType[type];
  const index = ApprovalIndex[type];
  return count > 0
    ? { text: `未確認の${text}が${count}件あります。`, color: "red", index }
    : { text: `未確認の${text}はありません。`, color: "blue", index };
};

const routerName2 = "/AlertDetailList";
const items2 = ref<Banner2[]>([]);

const getBanner2 = (count = 0): Banner2 => {
  console.log("count", count);
  return count > 0
    ? { text: `未申請のアラートがあります。`, color: "red" }
    : { text: `未申請のアラートはありません。`, color: "blue" };
};

const getAllCount = async (path: string): Promise<number> => {
  const request: CheckApprovalSearchRequest = {
    approvals: [EnumApprovalState.RESOLVE, EnumApprovalState.REJECT],
    checkApprovalManager: EnumCheckApproval.No
  };
  const response = await $post<CheckApprovalAttendance[]>(path, request);
  return response ? response.length : 0;
};

const getShiftItems = async (): Promise<Banner> => {
  // const path = Paths.checkApproval.shift.search;
  const path = Paths.checkApproval.shift.searchhome;
  const count = await getAllCount(path);
  return getBanner("Shift", count);
};

const getVacationItems = async (): Promise<Banner> => {
  // const path = Paths.checkApproval.vacation.search;
  const path = Paths.checkApproval.vacation.searchhome;
  const count = await getAllCount(path);
  return getBanner("Vacation", count);
};

const getOverworkItems = async (): Promise<Banner> => {
  // const path = Paths.checkApproval.overwork.search;
  const path = Paths.checkApproval.overwork.searchhome;
  const count = await getAllCount(path);
  return getBanner("Overwork", count);
};

const getAttendanceItems = async (): Promise<Banner> => {
  // const path = Paths.checkApproval.attendance.search;
  const path = Paths.checkApproval.attendance.searchhome;
  const count = await getAllCount(path);
  return getBanner("Attendance", count);
};

const getEarlytimeItems = async (): Promise<Banner> => {
  // const path = Paths.checkApproval.earlytime.search;
  const path = Paths.checkApproval.earlytime.searchhome;
  const count = await getAllCount(path);
  return getBanner("Earlytime", count);
};

const getSelfCount2 = async (path: string): Promise<number> => {
  const request: PetitionShiftAttendanceSearchRequest = {
    lostStamp: 1,
    lateStamp: 1,
    earlyStamp: 1,
    overwork: 1,
    holyWork: 1,
    notStamp: 1
  };
  const encode = encodeURI(JSON.stringify(request));
  const response = await $get(path, "query=" + encode);
  console.log("response", response.items.length);
  return response.items.length;
};

const getAlertItems = async (): Promise<Banner2> => {
  const path = Paths.alert.list;
  const response = await getSelfCount2(path);
  console.log("countresponse", response);
  return getBanner2(response);
};

const getItems = async () => {
  return await Promise.all([
    getShiftItems(),
    getVacationItems(),
    getOverworkItems(),
    getAttendanceItems(),
    getEarlytimeItems()
  ]);
};

const getItems2 = async () => {
  return await Promise.all([getAlertItems()]);
};

const onAll = (item: Banner) => {
  router.push({ name: routerName, params: { value: String(item.index) } });
};

const onOnlyAlert = (item: Banner2) => {
  // approval.resetForm();
  router.push(routerName2);
};

onMounted(async () => {
  items.value = await getItems();
  items2.value = await getItems2();
});

return { __sfc: true,router, ApprovalType, ApprovalIndex, items, routerName, getBanner, routerName2, items2, getBanner2, getAllCount, getShiftItems, getVacationItems, getOverworkItems, getAttendanceItems, getEarlytimeItems, getSelfCount2, getAlertItems, getItems, getItems2, onAll, onOnlyAlert }
}

})